export const PagesTypes: {
  Direct_To_Customer_OfferSummary: string;
  M3_TermsAndConditions: string;
  M3_PrivacyPolicy: string;
  M3_IdentificationUploader: string;
  M3_ExternalIdUploader: string;
  M3_CreditCheckPermissionView: string;
  M3_CustomerContactInfoView: string;
  M3_Contract: string;
  M3_Offers: string;
  M3_SelfOnboardingSummary: string;
  M3_Software: string;
  M3_Complete: string;
} = {
  Direct_To_Customer_OfferSummary: "directtocustomeroffersummary",
  M3_TermsAndConditions: "registration",
  M3_PrivacyPolicy: "registration",
  M3_IdentificationUploader: "registration",
  M3_ExternalIdUploader: "registration",
  M3_CreditCheckPermissionView: "registration",
  M3_CustomerContactInfoView: "registration",
  M3_Offers: "offers",
  M3_SelfOnboardingSummary: "selfonboardsummary",
  M3_Contract: "contract",
  M3_Software: "software",
  M3_Complete: "checkout",
};
